import { FilterOrder, FilterOrders } from "#/organisms";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";

import { OrderFilterParams } from "@/api/order/interface";
import { Orders } from "@/components/pages";
import { useApi } from "@/api";
import { useFilter } from "@/hooks";
import { useNavigate } from "react-router-dom";

const OrdersView = () => {
  const { order, session } = useApi();
  const {
    filter,
    numberOfFilters,
    onOpenFilter,
    setShouldFilter,
    shouldFilter,
    showFilter,
    ...filterProps
  } = useFilter<FilterOrder>();
  const [called, setCalled] = useState(false);
  const page = useRef(1);
  const navigate = useNavigate();

  const isAdmin = useMemo(() => session.user?.admin || false, [session.user]);
  
  const getOrders = async (filterData?: OrderFilterParams, append?: boolean) => {
    if (append && filterData)
      filterData.page = page.current;
    await order.getOrderList(filterData, append);
  }

  const fetchOrders = (append?: boolean) => {

    if (filter) {
        getOrders(filter && {
          customerCode: filter.customerCode,
          customerEmail: filter.customerEmail,
          customerName: filter.companyName,
          dateFrom: filter.dateFrom,
          dateTo: filter.dateTo,
          maintainerId: 'not-set',
          orderState: filter.state || null,
          propertyAddress: filter.location,
        }, append);
      } else {
        getOrders({
          maintainerId: 'not-set'
        }, append);
      }
  }

  useEffect(() => {
    if (order.orders.length === 0 || !called) {
      setCalled(true);
      getOrders({
        maintainerId: 'not-set'
      });
    }
  }, []);

  useEffect(() => {
    if (shouldFilter) {
      fetchOrders();
      setShouldFilter(false);
    }
  }, [filter, shouldFilter]);

  const handleCreateNewOrder = useCallback(() => {
    navigate('/order-create');
  }, []);

  const handleSelectOrder = useCallback((orderId: string) => {
    navigate(`/order-view-backend/order=${orderId}`);
  }, []);

  const handleFetchMore = async () => {
    page.current += 1;
    fetchOrders(true);
  }

  return (
    <>
      <Orders
        hasMore={order.orders.length % 50 === 0}
        isAdmin={isAdmin}
        loading={false}
        numberOfFilters={numberOfFilters}
        orders={order.orders}
        onCreateNewOrder={handleCreateNewOrder}
        onFetchmore={handleFetchMore}
        onOpenFilter={onOpenFilter}
        onSelectOrder={handleSelectOrder}
      />
      {showFilter && <FilterOrders {...filterProps} filter={filter} numberOfFilters={numberOfFilters} showAdminFilter={isAdmin} />}
    </>
  );
}

export default OrdersView;